export const DEVICE_ACTION_TYPE_LABELS: Readonly<Record<number, string>> = {
  1: 'Biométrico',
  2: 'Tarjeta',
  3: 'PIN',
  4: 'Rostro',
  5: 'Iris',
  6: 'Huella+Tarjeta',
  7: 'Huella+Tarjeta+PIN',
  8: 'Placa',
  9: 'Usuario',
  10: 'Rostro (Móvil)',
  11: 'Rostro (PC)',
  12: 'Biométrico (PC)',
  13: 'PIN (PC)',
  14: 'PIN (Móvil)',
  15: 'Computador',
  16: 'Teléfono',
  17: 'Palma',
};

export function mapDeviceActionTypeToFuente(id?: number | null): string {
  if (id === undefined || id === null) return '—';
  return DEVICE_ACTION_TYPE_LABELS[id] ?? 'Desconocido';
}

export function extractSede(description?: string | null): string {
  if (!description) return '—';
  const [first] = description.split('·');
  return (first ?? '').trim() || '—';
}
